import { render, staticRenderFns } from "./SessionLimitationModal.vue?vue&type=template&id=40463298&"
import script from "./SessionLimitationModal.vue?vue&type=script&lang=ts&"
export * from "./SessionLimitationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports